module.exports = __webpack_public_path__ + "img/deliveboo-2.0720d69d.png";